export default __webpack_public_path__ + "static/media/ecosystemCircles.3a641ec4.png";